import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { TRACKING_EVENTS } from "utils";
import CheckoutPreview from "../components/Checkout-Preview";
import PaymentOptions from "../components/PaymentOptions";

function Checkout() {
 const [isPayementOptionPage, setIsPayementOptionPage] = useState(false);
 const { cartTotal } = useSelector((state) => state.cart);
 const checkoutTracked = useRef(false);

useEffect(()=>{
 return ()=>{
  setIsPayementOptionPage(false);
 }
},[])

// InitiateCheckout, once the basket total is known.
//
// cartTotal is 0 on the first render while the cart rehydrates, and an event
// carrying a zero value is worse than none -- it teaches the ad platform the
// wrong number. The ref stops a re-render firing it a second time.
useEffect(()=>{
 if (checkoutTracked.current || !cartTotal) return;
 checkoutTracked.current = true;
 TRACKING_EVENTS.initiateCheckout(cartTotal);
},[cartTotal])

 return (
    isPayementOptionPage ? <PaymentOptions setIsPayementOptionPage={()=>setIsPayementOptionPage(false)} /> : <CheckoutPreview setIsPayementOptionPage={()=>setIsPayementOptionPage(true)} />
 )
}

export default Checkout;
